module.exports = __webpack_public_path__ + "img/zggd1.54f9d6f4.png";